import Vue from 'vue'
import VueI18n from 'vue-i18n'

import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhCNLocale from 'element-ui/lib/locale/lang/zh-CN'
import enUSLocale from './en-US'
import zhCNLocale from './zh-CN'

const zh_cn = require ('@/assets/languages/zh_cn.json');
const en_us = require ('@/assets/languages/en_us.json');
console.log(zh_cn,en_us)



Vue.use (VueI18n)


const messages = {
  en_us: {
    ...enUSLocale,
    ...elementEnLocale,
    ...en_us
  },
  zh_cn: {
    ...zhCNLocale,
    ...elementZhCNLocale,
    ...zh_cn
  }
}

// 注册i18n实例并引入语言文件，文件格式等下解析
const i18n = new VueI18n ({
  locale: 'zh_cn',
  // messages: {
  //   'zh_cn': require('@/assets/languages/zh_cn.json'),
  //   'en_us': require('@/assets/languages/en_us.json')
  // }
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js